import request from '@/utils/request'

export function getBlocksList(data) {
  return request({
    url: 'api/v1/tetris-blocks/list',
    method: 'post',
    data: data
  })
}

export function updateBlocks(data) {
  return request({
    url: 'api/v1/tetris-blocks/update',
    method: 'post',
    data: data
  })
}

export function delBlocks(data) {
  return request({
    url: 'api/v1/tetris-blocks/delete',
    method: 'delete',
    data: data
  })
}

export function exportBlocks() {
  return request({
    url: 'api/v1/tetris-blocks/export',
    method: 'get'
  })
}

export function importBlocks(data) {
  return request({
    url: 'api/v1/tetris-blocks/import',
    method: 'post',
    data: data
  })
}

export function getBlocksIDNameMap(data) {
  return request({
    url: 'api/v1/tetris-blocks/id-name-map',
    method: 'post',
    data: data
  })
}
